import { AbstractNotification } from '../abstract.notification'
import { NotificationType } from '../notification-type.enum'

export class NotEnoughKeyNotification extends AbstractNotification {
	id = NotificationType.NOT_ENOUGH_MEMORY_KEY

	constructor() {
		super()
	}
}
